import Spinner from 'components/shared/app/Spinner';
import Button from 'components/shared/app/Button';
import CurrencyInput from 'components/shared/app/CurrencyInput';
import React, { useState } from 'react';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';

const SignupGoals = (props) => {
    const [error, setError] = useState(props.error);
    const [revenueGoal, setRevenueGoal] = useState(props.goals.revenueGoal || 0);
    const [aovGoal, setAovGoal] = useState(props.goals.aovGoal || 0);
    const [cppGoal, setCppGoal] = useState(props.goals.cppGoal || 0);

    const submit = () => {
        if (!revenueGoal || !aovGoal || !cppGoal) {
            return setError("Please enter a value for all goals.    ");
        }

        props.submitGoals({ revenueGoal, aovGoal, cppGoal });
    }

    return (
        <div className="step signup-goals form">

            <div className="font-plain-large bold pad tn center">Enter Your goals:</div>

            <div className="flex-col goal-info">
                <div className="pad sm ns">
                    <div className="font-label pad tn ns">Monthly Revenue Goal:</div>
                    <CurrencyInput color="default" name="revenue" canEdit noEditButton onChange={(val) => setRevenueGoal(val)} value={revenueGoal} />
                </div>

                <div className="pad sm ns">
                    <div className="font-label pad tn ns">Monthly Average Order Goal:</div>
                    <CurrencyInput color="dark default" name="aov" canEdit noEditButton onChange={(val) => setAovGoal(val)} value={aovGoal} />
                </div>

                <div className="pad sm ns">
                    <div className="font-label pad tn ns">Monthly Cost Per Purchase Goal:</div>
                    <CurrencyInput color="dark default" name="cpp" canEdit noEditButton onChange={(val) => setCppGoal(val)} value={cppGoal} />
                </div>
            </div>

            <div className="button-row col margin lg ns">
                <Button className="margin lg" round simple bold filled center color="white" icon={props.loading ? <Spinner size="fit" className="icon" color="blue" /> : <img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={submit}>
                    Submit
                </Button>
                <Button className="margin lg" round simple bold center color="white" textPosition="center" onClick={() => props.setSignupState(2)}>
                    Back
                </Button>
            </div>

            {error != '' && <div className="error status center font-plain-medium">{error}</div>}

        </div>
    )
}

export default SignupGoals;